import { render, staticRenderFns } from "./ReportingToTag.vue?vue&type=template&id=06cc72b8&scoped=true"
import script from "./ReportingToTag.vue?vue&type=script&lang=js"
export * from "./ReportingToTag.vue?vue&type=script&lang=js"
import style0 from "./ReportingToTag.vue?vue&type=style&index=0&id=06cc72b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc72b8",
  null
  
)

export default component.exports